import React from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { IconButton } from "@components/IconButton/IconButton";
import { BinIcon } from "@components/icons";
import { useApiErrorUtils } from "@hooks/useApiErrorUtils";
import { type IJointBillServicePeriodVoucher } from "@services/overview/types";
import { useRemoveVoucherMutation } from "@services/vouchers/mutations";
import { formatPrice } from "@utils/units";

interface IJointBillVoucherSummaryProps {
  vouchers: IJointBillServicePeriodVoucher[];
  jointBillServiceId: number;
}

export const JointBillVoucherSummary: React.FC<
  IJointBillVoucherSummaryProps
> = ({ vouchers, jointBillServiceId }) => {
  const { t } = useTranslation();

  const grantedDiscount = vouchers[0]?.grantedDiscount ?? 0;
  const voucherId = vouchers[0]?.voucherId;

  const { mutateAsync: removeVoucherMutation, isPending } =
    useRemoveVoucherMutation();

  const { toastApiError } = useApiErrorUtils();

  const remooveVoucher = () => {
    void removeVoucherMutation({
      voucherId: voucherId!,
      jointBillServiceId: jointBillServiceId,
    })
      .then(() => toast.success("bill.voucher.summary.removeVoucher.success"))
      .catch(toastApiError);
  };

  return (
    <div className="mt-[6.5px] flex flex-col items-end">
      <div className="flex items-center">
        <span>{t("bill.voucher.summary.discountAmount")}</span>
        <IconButton
          className="mx-1"
          iconClassName="size-4"
          onClick={remooveVoucher}
          icon={BinIcon}
          disableGroup
          isLoading={isPending}
        />
        <span className="text-lg font-semibold text-base-green">
          {formatPrice(grantedDiscount)}
        </span>
      </div>
    </div>
  );
};
